var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.999,
    cy: 60.9912,
    r: 51.6279,
    fill: "#0195D3",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60.9883,
    r: 59.5,
    stroke: "#D9EFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8196 66.4537C68.5115 66.4537 68.2034 66.3402 67.9601 66.097C67.4899 65.6267 67.4899 64.8483 67.9601 64.3781L71.252 61.0862L67.9601 57.7943C67.4899 57.324 67.4899 56.5456 67.9601 56.0754C68.4304 55.6051 69.2088 55.6051 69.679 56.0754L73.8304 60.2267C74.3007 60.697 74.3007 61.4754 73.8304 61.9456L69.679 66.097C69.4358 66.3402 69.1277 66.4537 68.8196 66.4537Z",
    fill: "#0195D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8579 62.2995H56.3666C55.7017 62.2995 55.1504 61.7482 55.1504 61.0834C55.1504 60.4185 55.7017 59.8672 56.3666 59.8672H72.8579C73.5228 59.8672 74.0741 60.4185 74.0741 61.0834C74.0741 61.7482 73.5228 62.2995 72.8579 62.2995Z",
    fill: "#0195D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6086 75.1782C51.2576 75.1782 45.4199 69.3406 45.4199 60.9895C45.4199 52.6384 51.2576 46.8008 59.6086 46.8008C60.2735 46.8008 60.8248 47.3521 60.8248 48.017C60.8248 48.6818 60.2735 49.2331 59.6086 49.2331C52.6845 49.2331 47.8523 54.0654 47.8523 60.9895C47.8523 67.9136 52.6845 72.7459 59.6086 72.7459C60.2735 72.7459 60.8248 73.2972 60.8248 73.9621C60.8248 74.6269 60.2735 75.1782 59.6086 75.1782Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutModal);
export default __webpack_public_path__ + "static/media/logout-modal.096993753fef03145de71bd00912569f.svg";
export { ForwardRef as ReactComponent };